import React, { useState } from 'react';
import styled from 'styled-components';
import { JRCIcon } from '../JRCIcon/JRCIcon';

/**
 * Interface of a single Menu Item  props
 * @member label string content of the menu item
 * @member clickHandler function (event?: React.MouseEvent)=> void, callback called when onClick the menu item
 */
export interface JRCMenuItemProps {
    label: string | JSX.Element;
    clickHandler: (event?: React.MouseEvent) => void;
}
/**
 * Interface to provide Menu props
 * @member items List of MenuItem props @see JRCMenuItemProps
 * @member defaultActiveItem optional index [0,items.length-1] of the defaultActive item when mounting 

 */
export interface JRCMenuProps {
    items: JRCMenuItemProps[];
    defaultActiveItem?: number;
}

export const MenuWrapper = styled.div``;

interface MenuItemProps {
    isActive: boolean;
}
export const MenuItem = styled.div<MenuItemProps>`
    &&& {
        position: relative;
        display: flex;
        vertical-align: middle;
        justify-content: space-between;
        align-items: center;
        width: 230px;
        height: 50px;
        border: none;
        background-color: ${(props) => props.theme.color.white};
        padding-left: 20px;
        padding-right: 20px;
        border-bottom: ${(props) => 'solid 1px ' + props.theme.color.grey1};
        border-left: ${(props) => (props.isActive ? 'solid 1px ' + props.theme.color.grey3 : '')};
        cursor: pointer;
    }
`;
export const MenuItemLabel = styled.span`
    &&& {
        border: 0;
        appearance: none;
        display: inline-block;
        text-align: start;
        align-items: center;
    }
`;

/**
 *
 * @param {items, defaultActiveItem} Menu props, @see JRCMenuProps interface
 * @returns JSX.Element
 */
export const JRCMenu = ({ items, defaultActiveItem }: JRCMenuProps): JSX.Element => {
    const [activeItem, setActiveITem] = useState(defaultActiveItem ? defaultActiveItem : 0);
    const clickOnItem = (index: number): void => {
        setActiveITem(index);
        items[index].clickHandler();
    };
    return (
        <MenuWrapper>
            {items.map((menuItem, index) => (
                <MenuItem onClick={() => clickOnItem(index)} key={index} isActive={activeItem == index}>
                    <MenuItemLabel>{menuItem.label}</MenuItemLabel> <JRCIcon name="icon-angle-right" />
                </MenuItem>
            ))}
        </MenuWrapper>
    );
};
